import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UiState } from './ui.state';

// export const selectUiState = (state: AppState) => state.ui;
export const selectUiStateSelector = createFeatureSelector<UiState>('ui');

export const selectUserIdle = createSelector(selectUiStateSelector, state => state.isUserIdle);
